/**
 * A mapping between key names and official names
 */
var KeyShorthandDictionary = {
  'cmd': 'Meta'
};
export default KeyShorthandDictionary;